import { render, staticRenderFns } from "./adminTrainingSlideTab.vue?vue&type=template&id=a86ed746&"
import script from "./adminTrainingSlideTab.vue?vue&type=script&lang=js&"
export * from "./adminTrainingSlideTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports